<template>
  <item-layout>
    <div
      slot="title"
      class="item-tit-box"
    >
      <template>
        <template v-if="isSystem">
          <span
            v-if="!isCofigFormEdit"
            class="item-tit"
          >{{ dataInfo.fieldname }}</span>
          <template>
            <add-layout-form
              type="edit"
              :data-info="dataInfo"
              @addEdit="addEdit"
            />
            <a
              v-if="!isCofigFormEdit"
              href="javascript:;"
              @click="delConfigForm"
            >{{ $t('message["962"]') }}</a>
          </template>
        </template>
        <template v-else>
          <span class="item-tit">{{ dataInfo.fieldname }}</span>
        </template>
      </template>
      <template v-if="dataInfo.fieldkey ==='deal_info'">
        <span class="deal-info-tip">{{ $t('message["528"]') }}</span>
      </template>
      <template v-else-if="dataInfo.fieldkey ==='invalid_info'">
        <span class="deal-info-tip">{{ $t('message["1764"]') }}</span>
      </template>
      <template v-else-if="dataInfo.fieldkey ==='discard_info'">
        <span class="deal-info-tip">{{ $t('message["1765"]') }}</span>
      </template>
    </div>
    <div slot="collect-item-con">
      <draggable
        v-if="child.length"
        v-model="items"
      >
        <child-item
          v-for="(item, index) in items"
          :key="item.id || item._id"
          :item-data="item"
          :parent-index="dataIndex"
          :index="index"
          :parent-fieldkey="dataInfo.fieldkey"
          @del="remove"
        />
      </draggable>
      <a-button
        v-if="dataInfo.fieldkey!=='base_info'"
        class="add-collect-item-btn"
        @click="add"
      >
        <i
          class="icon iconfont iconicon-test10"
        />

        {{ $t('message["1354"]') }}
      </a-button>
    </div>
  </item-layout>
</template>
<script>
// import Draggable from 'vuedraggable'
import ChildItem from './ChildItem'
import ItemLayout from './ItemLayout'
import AddLayoutForm from '../AddLayoutForm'
import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    ItemLayout,
    ChildItem,
    // Draggable,
    AddLayoutForm
  },
  props: {
    dataInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    dataIndex: {
      type: Number,
      default: 0
    },
    form: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isCofigFormEdit: false
    }
  },
  // mounted () {},
  computed: {
    ...mapState('config/collect', ['datas']),
    items: {
      set (value) {
        this.dataInfo.child = value
      },
      get () {
        return this.child
      }
    },
    child () {
      return this.dataInfo.child
    },
    isSystem () {
      return this.dataInfo.enabledelete
    }
  },
  methods: {
    ...mapMutations('config/collect', []),
    add () {
      this.dataInfo.child.push({
        fieldname: '',
        fieldtype: 'text',
        enabledelete: 1,
        isneeded: 0,
        isenable: 1,
        options: [],
        ischangeenable: 1,
        ischangename: 1,
        ischangeneeded: 1,
        ischangetype: 1,
        fieldconfig: {},
        _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime()
      })
    },
    remove (k) {
      // const { form } = this
      // const datas = form.getFieldValue(`fieldname[${this.dataIndex}]`)
      // const fieldtypeDatas = form.getFieldValue(`fieldtype[${this.dataIndex}]`)
      // if (datas.length === 1) {
      //   return
      // }
      // datas.splice(k, 1)
      // fieldtypeDatas.splice(k, 1)
      // form.setFieldsValue({
      //   [`fieldname[${this.dataIndex}]`]: datas,
      //   [`fieldtype[${this.dataIndex}]`]: fieldtypeDatas
      // })
      this.dataInfo.child.splice(k, 1)
    },
    addEdit () {
      this.isCofigFormEdit = !this.isCofigFormEdit
    },
    delConfigForm () {
      this.datas.splice(this.dataIndex, 1)
    }
    // dragEndHandle ({ oldIndex, newIndex }) {
    //   const item = this.dataInfo.child[oldIndex]
    //   this.dataInfo.child.splice(oldIndex, 1)
    //   this.dataInfo.child.splice(newIndex, 0, item)
    // }
  }
}
</script>
<style lang="scss" scoped>
.item-tit-box::v-deep {
  .item-tit{
    font-size: 18px;
    font-weight: 600;
    margin-right: 16px;
  }
  a {
    color: #5077aa;
  }
  .deal-info-tip {
    color: #b3b3b3;
  }
}
.add-collect-item-btn {
  margin:0 0 48px 38px;
  .iconicon-test10 {
    color: #ccc;
    font-size: 16px;
    margin-right: 6px;
  }
}
</style>
